import React, { createRef, useCallback, useState } from "react";
import { navigate } from "gatsby";

import { Button } from "../../Button";
import * as styles from "./search.module.less";

import { generateClassString as gcs } from "../../../lib/helper/generateClassString";
import { useScrollHandler } from "../../../lib/hooks/useScrollHandler";
import { useIsDesktop } from "../../../lib/hooks/mediaQueries";
import { Headline } from "../../Headline";
import LogoInfratec from "../../../../static/assets/logo-infratec.svg";

import { useInput } from "../../../lib/hooks/formHooks";

import t from "../../../lib/translate";
import { useEffect } from "react";

const searchPath = process.env.GATSBY_ROBOTS_SEARCH_PATH;

function SearchNav({ active = "", items = [] }) {
    const [show, setShow] = useState(false);
    const inputRef = createRef();
    const scrollPositionReached = useScrollHandler(100);
    const isMobile = useIsDesktop();

    const [focus, setFocus] = useState(false);

    const { value: searchInput, bind } = useInput("");

    const handleSearch = useCallback(
        (event) => {
            event.preventDefault();
            
            setShow(false)
            
            navigate(`${searchPath}?s=${searchInput}`);
        },
        [searchInput]
    );

    useEffect(() => {
        if (!show && !inputRef.current) {
            return;
        }

        inputRef.current.focus();
    }, [show, inputRef]);

    if (items.length === 0) {
        return (
            <div
                className={gcs(styles.buttonWrapper, [show, styles.activeMenu])}
            >
                <Button
                    type="secondary"
                    icon="search"
                    aria-label={t`navigation.iconNavigation.search`}
                    onClick={() => setShow(!show)}
                >
                    {t("navigation.iconNavigation.search")}
                </Button>
                {show && (
                    <div className={styles.widgetWrapper}>
                        <div
                            className={gcs(styles.langWrapper, [
                                scrollPositionReached && !isMobile,
                                styles.onScroll
                            ])}
                        >
                            <div className={styles.langContent}>
                                {isMobile && (
                                    <div className={styles.langHeader}>
                                        <div
                                            className={styles.langHeaderContent}
                                        >
                                            <img
                                                className={styles.logoInfratec}
                                                src={LogoInfratec}
                                                alt={"Infratec"}
                                            />
                                            <Button
                                                type={"secondary"}
                                                icon={"close"}
                                                onClick={() => setShow(!show)}
                                                iconPosition={"left"}
                                            />
                                        </div>
                                    </div>
                                )}
                                {!isMobile && (
                                    <div className={styles.claimer}>
                                        <Headline
                                            semanticOfHeadline={"H4"}
                                            hasLightBackground={"true"}
                                        >
                                            {t("page.search-form.aside-text")}
                                        </Headline>
                                    </div>
                                )}
                                <div className={styles.rightContainer}>
                                    <div className={styles.searchInputArea}>
                                        <form
                                            id="searchForm"
                                            className={gcs(styles.searchInput, [
                                                focus,
                                                styles.focused
                                            ])}
                                            onFocus={() => setFocus(true)}
                                            onBlur={() => setFocus(false)}
                                            onSubmit={handleSearch}
                                        >
                                            <input
                                                ref={inputRef}
                                                placeholder={t(
                                                    "page.search-form.placeholder"
                                                )}
                                                type={"text"}
                                                {...bind}
                                            />
                                        </form>
                                        <Button
                                            className={styles.searchButton}
                                            type={"cta"}
                                            icon={"search"}
                                            iconPosition={"left"}
                                            onClick={handleSearch}
                                        >
                                            {!isMobile && (
                                                <span>
                                                    {t(
                                                        "page.search-form.button"
                                                    )}
                                                </span>
                                            )}
                                        </Button>
                                    </div>
                                    {!isMobile && (
                                        <Button
                                            className={styles.closeButton}
                                            type={"secondary"}
                                            icon={"close"}
                                            onClick={() => setShow(!show)}
                                            iconPosition={"left"}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        <button
                            onClick={() => setShow(!show)}
                            className={styles.background}
                        />
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className={gcs(styles.buttonWrapper, [show, styles.activeMenu])}>
            <Button
                type="secondary"
                icon="search"
                aria-label={t`navigation.iconNavigation.search`}
                onClick={() => setShow(!show)}
            />
            {t("navigation.iconNavigation.search")}
        </div>
    );
}

export { SearchNav };
